(function () {
    'use strict';

    angular
        .module('planDeliverableModule')
        .directive('grcPlanDeliverable', directive);

    directive.$inject = ['boxTmplScope', 'boxTmplHtml', 'boxTmplLinkFn'];

    function directive(boxTmplScope, boxTmplHtml, boxTmplLinkFn) {

        var directiveScope            = _.clone(boxTmplScope);
        directiveScope.addDeliverable = '&';
        directiveScope.layoutRatio    = '=?';

        return {
            scope: directiveScope,
            template: boxTmplHtml,
            controller: ['$rootScope', '$scope', '$controller',
                function ($rootScope, $scope, $controller) {

                    /**
                     * @property {{
                     *          PlanDeliverableID,
                     *          PlanDeliverable: {TargetDateQuarterID, TargetFiscalYearAndQuarter}
                     *          Weight,
                     *          CompletionPercentage
                     *     }} boxModel
                     *
                     * @property {{
                     *     AssessmentByInitiative: {PlanInitiativeAssessment: {AreAllDeliverablesAssessed}},
                     *     AssessmentByInitiative: {PlanInitiativeAssessment: {AreAllDeliverablesAssessed}}
                     * }} boxContext
                     *
                     * @property {{
                     *     CompletionStatuses
                     * }} planLookups
                     *
                     * @property {{
                     *     boxType
                     * }} layoutRatio
                     */

                    // Box Template
                    $scope.baseTemplatePath = '/app/shared/grc/businessPlanning/deliverable/grcPlanDeliverable.[Template].tpl.html';
                    // Permissions default values
                    $scope.boxFeatureRole = $scope.boxFeatureRole || 'GRCBusinessPlanningManagement';
                    $scope.boxPermissionKey = $scope.boxPermissionKey || 'PlanDeliverable';

                    $controller('BoxTmplController', { $scope: $scope });

                    $scope.canEdit = $scope.boxPermissions.Edit;

                    $scope.ctrlCtxt           = {};
                    $scope.ctrlCtxt.isLoading = false;

                    $scope.getBoxClass = function () {
                        var defaultBoxType = 'is-nav',
                            clickable      = '';

                        if (!$scope.isBoxClickable) {
                            clickable = ' not-clickable-card';
                        }

                        if (_.isUndefined($scope.layoutRatio)) return defaultBoxType + clickable;
                        if (_.isUndefined($scope.layoutRatio.boxType)) return defaultBoxType + clickable;

                        return $scope.layoutRatio.boxType + clickable;
                    };

                    $scope.editDeliverable = function (deliverable) {
                        $scope.boxItemClick({item: deliverable});
                    };

                }],

            link: function (scope, elem, attrs) {

                boxTmplLinkFn(scope, elem, attrs);
            }
        }
    }
})();